export function redirectToService() {
  // récupérer dans le local storage
  const redirectURI = localStorage.getItem('redirectURI');
  window.location.href = redirectURI || "";
}